import React from "react";
import { ContainerStyled } from "../../../styles/styled";

const ActivePurchase = () => (
  <ContainerStyled>ActivePurchase</ContainerStyled>
);

export default ActivePurchase;
